import React, { useEffect, useState } from 'react';
import { DETAIL_PAGE } from '../../../../constants/UiBuilderConst';
import HotelModuleSelector from '../../../../shared/ui-builder/hotel-module-selector/Hotel-Module-Selector';
import ModuleIdSelector from '../../../../shared/ui-builder/module-id-selector/Module-Id-Selector';

const DetailPage = (props) => {
  const { onItemChange, config, handleError, componentNdx } = props;

  const initialState = {
    hotelModule: '',
    hotelModuleId: '',
  };

  const [configState, setConfigState] = useState(config?.hotelModule ? config : initialState);
  const [error, setError] = useState(null);

  useEffect(() => {
    onItemChange({
      componentName: DETAIL_PAGE,
      config: configState,
    });
  }, [configState]);

  const setErrorField = (field, val) => {
    if (val) return '';
    return 'required';
  };

  useEffect(() => {
    if (handleError && handleError.length > 0) {
      const currError = handleError.find(
        (getError) => getError.pos === componentNdx && getError.id === DETAIL_PAGE,
      );
      setError(currError ?? null);
    }
  }, [handleError]);

  const handleTabData = (val, slideContent, field) => {
    if (error) {
      const currError = { ...error };
      const currConfigError = { ...currError.config, [field]: setErrorField(field, val) };
      currError.config = currConfigError;
      setError(currError);
    }
    const tempConfigState = { ...configState };
    switch (field) {
      case 'hotelModule':
        tempConfigState.hotelModule = val;
        tempConfigState.hotelModuleId = '';
        break;
      case 'hotelModuleId':
        tempConfigState.hotelModuleId = val;
        break;
      default:
        break;
    }
    setConfigState(tempConfigState);
  };

  return (
    <div className='row my-2 mx-4'>
      <div className='col-md-12 mb-4'>
        <div className='mb-3'>
          <HotelModuleSelector
            hideNullOption
            hotelModule={configState.hotelModule}
            onChangeHotelModule={(e) => handleTabData(e, configState, 'hotelModule')}
            error={error?.config?.hotelModule === 'required' ? true : false}
            required={true}
          />
        </div>
        <div className='col-md-12 mb-3'>
          <div className='col-md-12 mb-3 mt-2'>Sub Module</div>
          <div className='col-md-12'>
            <ModuleIdSelector
              error={error?.config?.hotelModuleId === 'required' ? true : false}
              required={true}
              disabled={config?.hotelModule ? false : true}
              hideNullOption
              hotelModule={configState.hotelModule}
              hotelModuleId={configState.hotelModuleId}
              onChangeHotelModuleId={(e) =>
                handleTabData(e.target.value, configState, 'hotelModuleId')
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailPage;
